import { MutationTree } from 'vuex';
import IContactState from './types/IContactState';
import IContactMeta from './types/IContactMeta';
import IContactHeader from './types/IContactHeader';
import ITeamMember from './types/ITeamMember';

const mutations: MutationTree<IContactState> = {
  setMeta(state, meta: IContactMeta) {
    state.meta = meta;
  },

  setHeader(state, header: IContactHeader) {
    state.header = header;
  },

  setTeam(state, team: ITeamMember[]) {
    state.team = team;
  },
};

export default mutations;
